import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ReportRunnerService from '../../../Services/ReportRunnerSerivce';
import UnappliedPrepaymentReportSearchParams from './UnappliedPrepaymentReportSearchParams';

export default class UnappliedPrepaymentReportWindowDescription {
  static titleForCreate = 'Export Unapplied Prepayment Report';
  static titleForEdit = 'Export Unapplied Prepayment Report';
  static itemType = UnappliedPrepaymentReportSearchParams;
  static serviceFunction = ReportRunnerService.RequestUnappliedPrepaymentReport;
  static waitForServiceFunction = () => false;
  static finishButtonLabel = 'Export';
  static messageOnSuccess =
    'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'OfficeIds',
          label: 'Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeOrGroupMultiSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'ClientIds',
          label: 'Client',
          className: 'col-12',
          type: InputTypesEnum.ClientMultiChoiceAll,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
